import {Locale} from '../RootProvider/LocaleContext';
import {ObjectOfAny} from '../types';

interface RequiredNodeFields {
  node_locale: Locale;
  displayOnLocale: Locale[];
}

// filter for nodes that match the current locale and are flagged for display on that locale
export const getNodesByLocale = <T = ObjectOfAny>(
  nodes: (T & RequiredNodeFields)[],
  locale: Locale,
  language: Locale = locale
): (T & RequiredNodeFields)[] =>
  nodes.filter(
    (node: T & RequiredNodeFields) => node.node_locale === language && node.displayOnLocale?.includes(locale)
  );
